import { render, staticRenderFns } from "./Form5.vue?vue&type=template&id=470b5f91&scoped=true"
import script from "./Form5.vue?vue&type=script&lang=ts"
export * from "./Form5.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=470b5f91&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b5f91",
  null
  
)

export default component.exports